// Instâncias Evolution API conhecidas
export const INSTANCIAS_CONHECIDAS = [
  "fluxomed-sandbox",
  "dr-victor",
];

// Projetos Supabase conhecidos
export const SUPABASE_PROJECTS = [
  { value: "qbkhttznrbdzaeyuqtjm", label: "FluxoMed Operacional" },
  { value: "tfqxovzgrfecpdoemanp", label: "RC2Clicks CRM" },
];

// Especialidades médicas comuns
export const ESPECIALIDADES_MEDICAS = [
  "Dermatologia",
  "Otorrinolaringologia",
  "Ortopedia e Traumatologia",
  "Cardiologia",
  "Neurologia",
  "Ginecologia e Obstetrícia",
  "Pediatria",
  "Clínica Médica",
  "Urologia",
  "Oftalmologia",
  "Endocrinologia",
  "Psiquiatria",
  "Gastroenterologia",
  "Reumatologia",
  "Pneumologia",
  "Angiologia",
  "Cirurgia Geral",
];

// Convênios comuns para sugestão
export const CONVENIOS_COMUNS = [
  "Unimed",
  "Bradesco Saúde",
  "SulAmérica",
  "Amil",
  "CASSI",
  "Hapvida",
  "NotreDame Intermédica",
  "Porto Seguro Saúde",
  "Prevent Senior",
  "São Francisco Saúde",
  "Geap",
  "Planserv",
  "Fusex",
  "Postal Saúde",
  "Particular",
];

// Mensagens padrão pre-seed ao criar novo cliente
export const MENSAGENS_PADRAO = {
  menu_inicial:
`Olá! 👋 Sou o assistente de agendamento.

Antes de começar, me diz seu *nome completo*, por favor?`,

  coleta_nome:
`Certo! Qual é o seu nome completo?`,

  convenio_recusado:
`Infelizmente este convênio não é atendido.

Para mais informações, entre em contato diretamente com nossa secretária. 😊`,

  selecao_unidade:
`Qual unidade você prefere para a consulta?`,

  confirmacao_humana:
`Perfeito! ✅ Nossa secretária entrará em contato em breve para confirmar sua consulta.

Aguarde, por favor. 😊`,

  followup:
`Oi! 😊 Notei que você iniciou um atendimento mas não concluiu.

Posso te ajudar a agendar sua consulta?

1️⃣ Sim, quero continuar
2️⃣ Não, obrigado`,
};
